import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "p-modal-completed-thanks-point-send" }
const _hoisted_2 = { class: "p-modal-completed-thanks-point-send__inner" }
const _hoisted_3 = { class: "p-modal-completed-thanks-point-send__header" }
const _hoisted_4 = { class: "p-modal-completed-thanks-point-send__heading" }
const _hoisted_5 = { class: "p-modal-completed-thanks-point-send__body" }
const _hoisted_6 = { class: "p-modal-completed-thanks-point-send__body__image" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "p-modal-completed-thanks-point-send__body__name"
}
const _hoisted_9 = {
  class: "p-modal-completed-thanks-point-send__body__name__text",
  "data-translate-skip": ""
}
const _hoisted_10 = {
  key: 1,
  class: "p-modal-completed-thanks-point-send__body__name"
}
const _hoisted_11 = { class: "p-modal-completed-thanks-point-send__body__point" }
const _hoisted_12 = { class: "p-modal-completed-thanks-point-send__body__date" }
const _hoisted_13 = { class: "p-modal-completed-thanks-point-send__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconBalloonPresentBox = _resolveComponent("IconBalloonPresentBox")!
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_PointNotation = _resolveComponent("PointNotation")!
  const _component_SmallText = _resolveComponent("SmallText")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_ModalMain = _resolveComponent("ModalMain")!

  return (_openBlock(), _createBlock(_component_ModalMain, null, {
    fullBody: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.headingText), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_IconBalloonPresentBox, {
                class: "p-modal-completed-thanks-point-send__body__balloon p-modal-completed-thanks-point-send__body__balloon--l",
                size: _ctx.balloonIconSize
              }, null, 8, ["size"]),
              (!_ctx.isMultiGift)
                ? (_openBlock(), _createBlock(_component_IconUserImage, {
                    key: 0,
                    size: _ctx.profileIconSize
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.icon,
                        alt: ""
                      }, null, 8, _hoisted_7)
                    ]),
                    _: 1
                  }, 8, ["size"]))
                : _createCommentVNode("", true),
              _createVNode(_component_IconBalloonPresentBox, {
                class: "p-modal-completed-thanks-point-send__body__balloon p-modal-completed-thanks-point-send__body__balloon--r",
                size: _ctx.balloonIconSize
              }, null, 8, ["size"])
            ]),
            (!_ctx.isMultiGift)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.name), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isMultiGift)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalCompleteData.selectedUserCount) + "名へ送付しました ", 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_PointNotation, {
                point: _ctx.sendPoint,
                "icon-size": 32,
                "sign-is-exists": false
              }, null, 8, ["point"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", null, [
                _createVNode(_component_SmallText, {
                  size: 14,
                  color: "#333333"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.date), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("p", null, [
                _createVNode(_component_SmallText, {
                  size: 14,
                  color: "#333333"
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "text", {}, () => [
                      _createTextVNode("現在、" + _toDisplayString(_ctx.thanksPointName) + "は承認待ちです。承認結果はポイント確認ページからご確認いただけます。", 1)
                    ], true)
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_ButtonMain, {
              class: "p-modal-completed-thanks-point-send__button",
              tag: "a",
              kind: "secondary",
              href: _ctx.urlPointConfirmation
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("ポイント確認ページを見る", -1)
              ])),
              _: 1,
              __: [0]
            }, 8, ["href"]),
            _createVNode(_component_ButtonMain, {
              class: "p-modal-completed-thanks-point-send__button",
              tag: "button",
              kind: "cancel",
              onClickButton: _ctx.closeModal
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("閉じる", -1)
              ])),
              _: 1,
              __: [1]
            }, 8, ["onClickButton"])
          ])
        ])
      ])
    ]),
    _: 3
  }))
}